import getConfig from 'next/config';

const { CORE_URL } = getConfig().publicRuntimeConfig;

export const formatUrl = (basePath: string, asPath: string) => {
  let pathName = asPath.replace(/utm_.*?(&|$)/g, '');

  if (['&', '?'].includes(pathName[pathName.length - 1])) {
    pathName = pathName.slice(0, -1);
  }

  return `${CORE_URL}${basePath}${pathName}`;
};
